import {api} from '../../helpers';
import {getCookieValue} from '../../helpers/getCookie';
const subUrl = '/reconciliation';
const env = getCookieValue('env');
const environment = env === 'Production' ? 'live' : env;

function fetchOverview({params}) {
  return api
    .get(`${subUrl}/fraud/overview`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchOverviewAlertsChart({params}) {
  return api
    .get(`${subUrl}/fraud/overview/alerts-chart`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchAccountsTierOverview(params = {}) {
  return api
    .get(`${subUrl}/fraud/users/overview`, {
      params: {
        ...params,
        env: environment?.toLowerCase(),
      },
    })
    .then(res => res.data);
}
function fetchResolvedCasesOverview({params}) {
  return api
    .get(`${subUrl}/fraud/overview/cases`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}

function fetchProfiles({params}) {
  return api
    .get(`${subUrl}/fraud/users`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchAccounts({params}) {
  return api
    .get(`${subUrl}/fraud/users`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchAccountDetails({account_id, params}) {
  return api
    .get(`${subUrl}/fraud/user/${account_id}`, {...params})
    .then(res => res.data);
}
function fetchFlaggedAndUnflaggedChart({account_id, params}) {
  return api
    .get(`${subUrl}/fraud/user/${account_id}/chart`, {params})
    .then(res => res.data);
}
function fetchAccountTransactions({account_id, params}) {
  return api
    .get(`${subUrl}/fraud/user/${account_id}/events`, {params: {...params}})
    .then(res => res.data);
}
function fetchAccountCases({account_id, params}) {
  return api
    .get(`${subUrl}/fraud/user/${account_id}/cases`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchFlows({params}) {
  return api
    .get(`${subUrl}/fraud/all`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchFlow(flow_id) {
  return api.get(`${subUrl}/fraud/${flow_id}`).then(res => res.data);
}
///////////////////////    FLOW TEMPLATES  ///////////////////////
function fetchRuleTemplates(params = {}) {
  return api
    .get(`${subUrl}/fraud/rule-templates`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchTemplateRules(template_id) {
  return api
    .get(`${subUrl}/fraud/rule-template/${template_id}`)
    .then(res => res.data);
}
function fetchTemplateRuleDetails({template_id, rule_id}) {
  return api
    .get(`${subUrl}/fraud/rule-template/${template_id}/rule/${rule_id}`)
    .then(res => res.data);
}

function createBulkRuleFromTemplate(data) {
  return api.post(`${subUrl}/rule/rules/bulk`, {...data}).then(res => res.data);
}

///////////////////////    LISTS  START  ///////////////////////
const listsBaseUrl = '/users/fraud-detection/cases';

function fetchCustomLists(params) {
  return api.get(`${listsBaseUrl}/lists`, {...params}).then(res => res.data);
}
function fetchACustomList(list_id) {
  return api.get(`${listsBaseUrl}/lists/${list_id}`).then(res => res.data);
}

function fetchRuleListAssociation(association_id) {
  return api
    .get(`${listsBaseUrl}/list-association?rule=${association_id}`)
    .then(res => res.data);
}
function fetchRuleListAssociations() {
  return api.get(`${listsBaseUrl}/list-association`).then(res => res.data);
}

function createRuleListAssociation(data) {
  return api
    .post(`${listsBaseUrl}/list-association`, {...data})
    .then(res => res.data);
}

///////////////////////    LISTS  END  ///////////////////////

function createFlow(data) {
  return api
    .post(`${subUrl}/fraud`, {...data, env: environment?.toLowerCase()})
    .then(res => res.data);
}
function updateFlow({id, data}) {
  return api
    .put(`${subUrl}/fraud/project/${id}`, {...data})
    .then(res => res.data);
}
function generateWebhookUrl(data) {
  return api
    .post(`/baas/wallet/setup_webhook_url`, {...data})
    .then(res => res.data);
}
function deleteFlow(flow_id) {
  return api.delete(`${subUrl}/fraud/project/${flow_id}`).then(res => res.data);
}
function fetchEvents({params}) {
  return api
    .get(`${subUrl}/fraud/events`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchEventDetails(eventId) {
  return api.get(`${subUrl}/fraud/event/${eventId}`).then(res => res.data);
}
function fetchCases({params}) {
  return api
    .get(`${subUrl}/fraud/cases`, {
      params: {...params, env: environment?.toLowerCase()},
    })
    .then(res => res.data);
}
function fetchCase(case_id) {
  return api.get(`${subUrl}/fraud/case/${case_id}`).then(res => res.data);
}
function updateCase({case_id, data}) {
  return api
    .put(`${subUrl}/fraud/case/${case_id}`, {...data})
    .then(res => res.data);
}
function generateSampleData(id) {
  return api
    .get(`${subUrl}/fraud/generate-transactions/${id}`)
    .then(res => res.data);
}
function fetchAvailableFields() {
  return api.get(`${subUrl}/rule/available-facts`).then(res => res.data);
}

function fetchTasks(flowId) {
  return api
    .get(`${subUrl}/rule/project/${flowId}/staged`)
    .then(res => res.data);
}

function fetchPublishedTasks(flowId) {
  return api.get(`${subUrl}/rule/rules/${flowId}`).then(res => res.data);
}
//////////// VERSION HISTORY ////////////////

function fetchAllVersionHistory(flow_id) {
  return api
    .get(`${subUrl}/rule/project/${flow_id}/versions`)
    .then(res => res.data);
}
function fetchVersionRules({flow_id, version_id}) {
  return api
    .get(`${subUrl}/rule/project/${flow_id}/version/${version_id}`)
    .then(res => res.data);
}

function rollBackVersion(data) {
  return api
    .post(`${subUrl}/rule/project/${data?.project_id}/rollback`, {...data})
    .then(res => res.data);
}

function addTask(flowId, newTask) {
  return api
    .post(`${subUrl}/rule/rule`, {...newTask, project_id: flowId})
    .then(res => res.data);
}
function publishTasks(flowId, userId) {
  return api
    .post(`${subUrl}/rule/project/${flowId}/commit`, {updated_by: userId})
    .then(res => res.data);
}

function updateTask(flowId, {id, ...task}) {
  return api
    .put(`${subUrl}/rule/rule/${id}`, {...task, project_id: flowId})
    .then(res => res.data);
}

function saveProcess(flowId, flowProcess) {
  const start = flowProcess[0];
  const end = flowProcess[2];
  const FLOW = [start, ...flowProcess[1], end];
  const threshold = flowProcess[2]?.threshold;

  const finalProcess = {
    process: FLOW.map(process => process?._id).filter(process => !!process),
    ...(threshold && {threshold}),
  };

  return api
    .put(`/users/fraud-detection/${flowId}/process`, {...finalProcess})
    .then(res => res.data);
}
function deleteTask({id, userId}) {
  return api
    .delete(`${subUrl}/rule/rule/${id}`, {data: {updated_by: userId}})
    .then(res => res.data);
}
function clearProjectRule(flowId) {
  return api
    .delete(`${subUrl}/rule/project/${flowId}/staged`)
    .then(res => res.data);
}

////////////////////    COMPANY SUBSCRIPTION AND PAYMENTS  ///////////////////////
function fetchSubscription() {
  return api.get(`${subUrl}/payment/subscription`).then(res => res.data);
}
function cancelSubscription() {
  return api.post(`${subUrl}/payment/cancel`).then(res => res.data);
}
function cardUpdateInitialize(data) {
  return api
    .post(`${subUrl}/payment/card/update/initialize`, {...data})
    .then(res => res.data);
}
function cardUpdateValidate(data) {
  return api
    .post(`${subUrl}/payment/card/update/validate`, {...data})
    .then(res => res.data);
}
function subscribeToPlan(data) {
  return api
    .post(`${subUrl}/payment/subscribe`, {...data})
    .then(res => res.data);
}
function validateSubscriptionPayment(data) {
  return api
    .post(`${subUrl}/payment/validate/subscription`, {...data})
    .then(res => res.data);
}
function fetchPaymentTransactions() {
  return api.get(`${subUrl}/payment/transactions`).then(res => res.data);
}
function fetchSubscriptionUsage() {
  return api.get(`${subUrl}/payment/usage`).then(res => res.data);
}

function initializePayment(data) {
  return api
    .post(`${subUrl}/payment/initialize`, {
      ...data,
    })
    .then(res => res.data);
}
function validatePayment(data) {
  return api
    .post(`${subUrl}/payment/validate`, {
      ...data,
    })
    .then(res => res.data);
}

////////////////////   COMPANY SETUP  ///////////////////////

function fetchCompany() {
  return api.get(`${subUrl}/fraud/company`).then(res => res.data);
}

function createCompany(data) {
  return api.post(`${subUrl}/fraud/company`, {...data}).then(res => res.data);
}
function updateCompanyConfigurations(data) {
  return api
    .put(`${subUrl}/fraud/company/setup-config`, {
      ...data,
    })
    .then(res => res.data);
}

export {
  addTask,
  fetchFlow,
  fetchCase,
  fetchFlows,
  fetchCases,
  deleteTask,
  fetchTasks,
  deleteFlow,
  updateFlow,
  updateCase,
  createFlow,
  updateTask,
  saveProcess,
  fetchEvents,
  fetchCompany,
  publishTasks,
  fetchOverview,
  createCompany,
  fetchAccounts,
  fetchProfiles,
  validatePayment,
  subscribeToPlan,
  rollBackVersion,
  fetchCustomLists,
  fetchACustomList,
  clearProjectRule,
  initializePayment,
  fetchEventDetails,
  fetchAccountCases,
  fetchVersionRules,
  fetchSubscription,
  generateSampleData,
  cancelSubscription,
  generateWebhookUrl,
  fetchRuleTemplates,
  fetchTemplateRules,
  cardUpdateValidate,
  fetchPublishedTasks,
  fetchAccountDetails,
  fetchAvailableFields,
  cardUpdateInitialize,
  fetchAllVersionHistory,
  fetchSubscriptionUsage,
  fetchOverviewAlertsChart,
  fetchPaymentTransactions,
  fetchTemplateRuleDetails,
  fetchRuleListAssociation,
  fetchAccountTransactions,
  fetchAccountsTierOverview,
  fetchRuleListAssociations,
  createRuleListAssociation,
  createBulkRuleFromTemplate,
  fetchResolvedCasesOverview,
  validateSubscriptionPayment,
  updateCompanyConfigurations,
  fetchFlaggedAndUnflaggedChart,
};
